<script setup lang="ts">
import type { AccordionItemCategory } from '#imports';

defineProps<{
  accordionItem: AccordionItemCategory;
}>();
</script>

<template>
  <ul
    v-if="accordionItem.content?.infoList?.length > 0"
    class="w-full"
    :aria-label="$t('Aria.Blocks.AccordionList', { headline: accordionItem.content.title })"
  >
    <li
      v-for="(infoItem, infoIndex) in accordionItem.content.infoList"
      :key="infoIndex"
      class="grid grid-flow-row grid-cols-2 border-b py-2"
    >
      <span>{{ infoItem.content.infoLabel }}</span>
      <span>{{ infoItem.content.infoValue }}</span>
    </li>
  </ul>
</template>
